module.exports = __webpack_public_path__ + "img/3.882fa831.webp";